module.exports = __webpack_public_path__ + "static/media/pick3-pple-animated-header.870028e4.png";